module.exports = __webpack_public_path__ + "img/brand-path-unbound.990252ef.svg";